export default __webpack_public_path__ + "static/media/extra_out_l9.c77eca36.svg";